import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    paper: {
        height: 140,
        width: 100,
        backgroundColor: 'var(--white)'
    },
    control: {
        padding: "2%",
        marginBottom: "2%",
        backgroundColor: 'var(--white)'
    },
    main: {
        paddingTop: '10%', minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            paddingTop: '32%',
        },
    },
    textField: {
        borderRadius: '5px',
        backgroundColor: 'var(--backgroundcolor)',
        padding: '5px 10px',
        fontSize: '16px',
        marginTop: '10px'
    },
    input: {
        color: 'var(--darker)'
    }
}));


function ContactDetail(props) {
    const classes = useStyles();
    const { phone, email, firstName, lastName } = props;
    const { dispatch } = props;

    useEffect(() => {
        if (props.country_code) {
            onChangePhone(props.country_code + "" + props.phone_number || "");
        }
    }, [props.country_code, props.phone_number]);

    const onChangePhone = (data) => {
        dispatch({ type: 'SET_PASSENGERS_PHONE', data })
    }

    const onChangeFirstName = (data) => {
        dispatch({ type: 'SET_PASSENGERS_FIRST_NAME', data })
    }

    const onChangeLastName = (data) => {
        dispatch({ type: 'SET_PASSENGERS_LAST_NAME', data })
    }

    const onChangeEmail = (data) => {
        dispatch({ type: 'SET_PASSENGERS_EMAIL', data })
    }

    return (
        <>
            <Typography
                variant="h6"
                style={{ color: "var(--darker)", textTransform: "capitalize" }}
            >{'Contact Details'}</Typography>
            <Grid item xs="12" style={{ marginTop: '10px' }}>
                <Paper className={classes.control} elevation={0}>
                    <Grid container spacing={4}>
                        {props.showName &&
                            <>
                                <Grid item xs="12" sm="6">
                                    <Typography component="p" style={{ textAlign: 'left' }}>First Name</Typography>
                                    <TextField
                                        error={firstName && firstName.length == 0}
                                        fullWidth
                                        value={firstName}
                                        className={classes.textField}
                                        InputProps={{
                                            className: classes.input,
                                            disableUnderline: true
                                        }}
                                        id="outlined-error-helper-text"

                                        helperText={firstName && firstName.length == 0 ? "First Name is required" : ''}
                                        // variant="outlined"
                                        onChange={(e) => onChangeFirstName(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs="12" sm="6">
                                    <Typography component="p" style={{ textAlign: 'left' }}>Last Name</Typography>
                                    <TextField
                                        error={lastName && lastName.length == 0}
                                        fullWidth
                                        value={lastName}
                                        className={classes.textField}
                                        InputProps={{
                                            className: classes.input,
                                            disableUnderline: true
                                        }}
                                        id="outlined-error-helper-text"

                                        helperText={lastName && lastName.length == 0 ? "Last Name is required" : ''}
                                        // variant="outlined"
                                        onChange={(e) => onChangeLastName(e.target.value)}
                                    />
                                </Grid>
                            </>
                        }
                        <Grid item xs="12" sm="6">
                            <Typography component="p" style={{ textAlign: 'left' }}>Email Address</Typography>
                            <TextField
                                error={email && email.length == 0}
                                fullWidth
                                value={email}
                                className={classes.textField}
                                InputProps={{
                                    className: classes.input,
                                    disableUnderline: true
                                }}
                                id="outlined-error-helper-text"

                                helperText={email && email.length == 0 ? "Email is required" : ''}
                                // variant="outlined"
                                onChange={(e) => onChangeEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs="12" sm="6">
                            <Typography component="p" style={{ textAlign: 'left' }}>Phone Number</Typography>
                            <TextField
                                error={phone && phone.length == 0}
                                fullWidth
                                value={phone ? phone : ''}
                                id="outlined-error-helper-text"

                                placeholder="+1 1234567890"
                                helperText={phone && phone.length == 0 ? "Phone is required" : ''}
                                // variant="outlined"
                                onChange={(e) => onChangePhone(e.target.value)}
                                className={classes.textField}
                                InputProps={{
                                    className: classes.input,
                                    disableUnderline: true
                                }}

                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </>

    )

}
// export default React.memo(ContactDetail);
const mapStateWithProps = (state) => {

    let country_code = ""
    let phone_number = ""
    if (state.user.userDetails && state.user.userDetails.country_code) {
        country_code = state.user.userDetails.country_code;
        phone_number = state.user.userDetails.phone_number;
    }
    else if (state.vendor.vendorDetail && state.vendor.vendorDetail.country_code) {
        country_code = state.vendor.vendorDetail.country_code;
    }
    return {
        email: state.flight.email,
        phone: state.flight.phone,
        firstName: state.flight.firstName,
        lastName: state.flight.lastName,
        userDetails: state.user.userDetails,
        phone_number: phone_number,
        country_code: country_code
    }
};



export default React.memo(connect(mapStateWithProps)(ContactDetail));